import { observable, runInAction } from "mobx"

import { Model } from "@/lib/Model.ts"

import type { PromptInputModel } from "@/components/PromptInput/PromptInputModel.ts"
import type { AiAgentTaskContextItem, GitFile } from "@/lib/client/generated/TypeDefinitions.ts"


export class AddContextModel extends Model {
  readonly open = observable.box(false)
  readonly inputValue = observable.box("")
  readonly listedPath = observable.box<string | null>(null)

  constructor(private readonly promptInputModel: PromptInputModel) {
    super("AddContextModel")
  }

  readonly setOpen = (open: boolean) => {
    runInAction(() => {
      this.open.set(open)
    })
  }

  readonly setInputValue = (value: string) => {
    runInAction(() => {
      this.inputValue.set(value)
    })
  }

  readonly setListedPath = (path: string | null) => {
    runInAction(() => {
      this.listedPath.set(path)
    })
  }

  readonly onOpen = (file: GitFile) => {
    this.setListedPath(file.path)
  }

  readonly onSelect = (file: GitFile) => {
    const contextItem = { name: file.path, type: file?.type == "DIR" ? "DIR" : "FILE" } as AiAgentTaskContextItem
    if (!this.promptInputModel.context.get().find(item => item.name === contextItem.name)) {
      runInAction(() => {
        this.promptInputModel.context.set(this.promptInputModel.context.get().concat(contextItem))
        this.setOpen(false)
      })
    }
  }

  readonly navigateUp = () => {
    const currentPath = this.listedPath.get()
    if (currentPath != null && currentPath != "") {
      const parentPath = currentPath.split("/").slice(0, -1).join("/")
      this.setListedPath(parentPath)
    }
  }

  readonly isFileInContext = (file: GitFile): boolean => {
    return this.promptInputModel.context.get().find(it => it.name === file.path) !== undefined
  }
}